import { store } from '@/store';
import AuthRedirectUtil from '@utils/AuthRedirectUtil';
import axios from 'axios';

export default function(params = {}) {
    // Create Axios object.
    params.baseURL = `${process.env.VUE_APP_API_URL}`;
    params.timeout = 60000; // 30 seconds.
    params.headers = {
        'Authorization': `Bearer ${store.getters.apiKey}`,
        'Accept-Language': store.getters.lang,
        'Content-Type': 'application/json',
    };
    let api = axios.create(params);

    // Global response handler.
    api.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized request.
            let route = window.router.currentRoute.name;
            if (error.response.data.message === 'mfa.required') {
                if (route !== 'mfa') {
                    const current = window.router.currentRoute;
                    if (['login', 'signup'].includes(current.name)) {
                        AuthRedirectUtil.rememberFromRoute(current);
                    } else if (current.fullPath) {
                        AuthRedirectUtil.remember(current.fullPath);
                    }
                    // Boot via AuthMiddleware redirects itself; only push mid-session.
                    if (store.getters.user) {
                        window.router.push({ name: 'mfa' }).catch(() => {});
                    }
                }
                return Promise.reject(error);
            } else {
                store.commit('logout');
                if (route !== 'login') window.router.push({ name: 'login' });
                return new Promise(() => {});
            }
        } else {
            return Promise.reject(error);
        }
    });

    return api;
}
